import $ from "jquery";
import "slick-carousel";
import "objectFitPolyfill";

export default () => {
  const $headerCarousel = $(".gallery__header"),
    $detailCarousel = $(".gallery__detail"),
    $warehouseCarousel = $(".gallery__warehouse");

  if ($headerCarousel.length > 0) {
    $headerCarousel.slick({
      infinite: true,
      dots: false,
      autoplay: true,
      arrows: false,
      fade: true,
      easing: "ease-in-out",
      speed: 2000,
      autoplaySpeed: 5000,
      lazyLoad: "progressive"
    });
  }

  if ($detailCarousel.length > 0) {
    $detailCarousel.slick({
      infinite: true,
      dots: false,
      autoplay: true,
      arrows: true,
      fade: true,
      easing: "ease-in-out",
      speed: 2000,
      autoplaySpeed: 5000,
      lazyLoad: "progressive",
      prevArrow: '<div class="gallery-prev"></div>',
      nextArrow: '<div class="gallery-next"></div>'
    });
  }

  if ($warehouseCarousel.length > 0) {
    $warehouseCarousel.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      arrows: true,
      easing: "ease-in-out",
      speed: 600,
      autoplaySpeed: 5000,
      prevArrow: '<div class="gallery-prev gallery-prev__warehouse"></div>',
      nextArrow: '<div class="gallery-next gallery-next__warehouse"></div>',
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            arrows: true,
            easing: "ease-in-out",
            speed: 600,
            autoplaySpeed: 5000,
            prevArrow:
              '<div class="gallery-prev gallery-prev__warehouse"></div>',
            nextArrow:
              '<div class="gallery-next gallery-next__warehouse"></div>'
          }
        }
      ]
    });
  }

  objectFitPolyfill();
};



// WEBPACK FOOTER //
// ./assets/js/modules/sliders.js